import React from 'react';
import AnalysisTextSection from './AnalysisTextSection';
import { Registry } from '@/graphql/__generated__/onboarding';
import { useNormalizedAntifraudData } from '@/hooks/useNormalizedAntifraudData';
import { NormalizedAntifraudData } from '@/utils/antifraudDataNormalizer';

interface BlackListsPEPProps {
	registry: Registry;
	normalizedData?: NormalizedAntifraudData | null;
	setOpenDetailedAnswerModal: React.Dispatch<React.SetStateAction<boolean>>;
	setDetailedAnswerModalContent: React.Dispatch<React.SetStateAction<any>>;
}

export const BlackListsPEP: React.FC<BlackListsPEPProps> = ({
	registry,
	normalizedData: propNormalizedData,
	setDetailedAnswerModalContent,
	setOpenDetailedAnswerModal
}) => {
	const hookNormalizedData = useNormalizedAntifraudData(registry);
	const normalizedData = propNormalizedData ?? hookNormalizedData;
	const isUnicoResponse = normalizedData?.isUnico || false;
	const hasPepData = normalizedData?.pep && normalizedData.pep.length > 0;
	const hasSanctionsData = normalizedData?.sanctions && normalizedData.sanctions.length > 0;
	const hasAnyData = hasPepData || hasSanctionsData;

	if (isUnicoResponse && !hasAnyData) {
		return null;
	}

	return (
		<div className="space-y-3">
			<AnalysisTextSection
				label="PEP"
				value={normalizedData?.pep}
				setDetailedAnswerModalContent={setDetailedAnswerModalContent}
				setOpenDetailedAnswerModal={setOpenDetailedAnswerModal}
			/>
			<AnalysisTextSection
				label="Sanctions"
				value={normalizedData?.sanctions}
				setDetailedAnswerModalContent={setDetailedAnswerModalContent}
				setOpenDetailedAnswerModal={setOpenDetailedAnswerModal}
			/>
			{!isUnicoResponse && (
				<AnalysisTextSection
					label="Warnings"
					value={normalizedData?.warnings}
					setDetailedAnswerModalContent={setDetailedAnswerModalContent}
					setOpenDetailedAnswerModal={setOpenDetailedAnswerModal}
				/>
			)}
		</div>
	);
};

export default BlackListsPEP;
